import { CopyColumnsType, conditionType } from "./interface";

export function formatDataSource(options: {
  /** 数据 */
  dataSource?: any[];
  /** 复制字段配置 */
  copyColumns?: CopyColumnsType[];
  /** 需要复制的字段集合 */
  fileldNames?: string[];
  /** 可选条件 */
  condition?: conditionType[];
  /** 是否为主子表 */
  isMainSubTable?: boolean;
  /** 子表数据字段 */
  subDataKey?: string;
}): {
  /** 复制字符串 */
  copyText: string;
  /** csv数据集合 */
  csvRows: any[][];
  /** 数据行数 */
  rows: number;
} {
  const { dataSource = [], copyColumns = [], fileldNames = [], condition = [], isMainSubTable = false, subDataKey = 'children', } = options;
  /** 复制字符串集合 */
  const copyRows: string[] = [];
  /** csv数据集合 */
  const csvRows: any[][] = [];
  /** 表格数据 */
  let newDataSource: any[] = [];
  if (isMainSubTable) {
    dataSource.forEach(item => {
      const { [subDataKey]: childrenItem, ...restItem } = item;
      if (condition.includes('main')) {
        newDataSource.push(restItem);
      }
      if (condition.includes('subTable')) {
        if (Array.isArray(childrenItem) && childrenItem.length) {
          childrenItem.forEach(v => {
            newDataSource.push(v);
          });
        }
      }
    });
  } else {
    newDataSource = dataSource;
  }
  const copyTitle: string[] = [];
  copyColumns.forEach(item => {
    const { name, title = '', } = item;
    if (name && fileldNames.includes(name)) {
      copyTitle.push(title)
    }
  });
  csvRows.push(copyTitle);
  if (condition.includes('title')) {
    // 复制标题
    const columsCopyStr = copyTitle.join(`\t`);
    copyRows.push(columsCopyStr);
  }
  newDataSource.forEach(record => {
    const rowCopyValues = getRecordCopyValues(record, fileldNames, copyColumns);
    const copyRow = rowCopyValues.join(`\t`);
    if (condition.includes('repeat')) {
      // 去重
      if (!copyRows.includes(copyRow)) {
        copyRows.push(copyRow);
        csvRows.push(rowCopyValues);
      }
    } else {
      copyRows.push(copyRow);
      csvRows.push(rowCopyValues);
    }
  });
  return {
    copyText: copyRows.join(`\r\n`),
    csvRows,
    rows: csvRows.length,
  };
}

/**
 * 根据选择的复制字段配置获取当前行复制的数据
 * @param record 
 * @param fileldNames 
 * @param copyColumns 
 * @returns 
 */
function getRecordCopyValues(record: any, fileldNames: string[], copyColumns: CopyColumnsType[]): string[] {
  const recordCopyValues: string[] = [];
  if (!record) return recordCopyValues;
  fileldNames.forEach(item => {
    const findColumn = copyColumns.find(v => v.name === item);
    if (findColumn) {
      recordCopyValues.push(getRecordCopyValue(record, findColumn));
    }
  });
  return recordCopyValues;
}

/**
 * 根据复制字段配置获取当前字段的值
 * @param record 当前行的数据
 * @param copyColumn 复制字段配置
 */
function getRecordCopyValue(record: any, copyColumn: CopyColumnsType) {
  const { name, formatValue } = copyColumn;
  if (formatValue) {
    const newValue = formatValue(record);
    return newValue ?? '';
  }
  if (name) return record[name] ?? '';
  return '';
}

/**
 * 
 * @param type 可选条件类型
 * @returns 
 */
export function renderConditionLabel(type: conditionType) {
  if (type === 'title') return '复制标题';
  if (type === 'repeat') return '去除重复数据';
  if (type === 'main') return '主表数据';
  if (type === 'subTable') return '子表数据';
}
